// this is an autogenerated file from DesignSystem/LetterRecipientPicker/Content/Recipient/AddProfessional/Content/query-get-person-by-professional-relationship.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_LetterRecipientPicker_Content_Recipient_AddProfessional_Content($id: numeric!) {
  vaxiom_professional_relationships_by_pk(id: $id) {
    id
    other {
      id
      person {
        id
        _id
      }
    }
  }
}

`